import { createContext } from 'react'

export const RequestProfileContext = createContext()
